import React from "react";
// import axios from 'axios';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { setCookie } from "./components/Cookie";
import loadable from "@loadable/component";
import Navigation from "./layouts/navbar";
import Footer from "./layouts/footer";
// import Loading from './layouts/loading';
import Scroll from "./functions/scroll/index.js";
import VideoProduction from "./pages/VideoProduction/";

// import TagManager from 'react-gtm-module'

// import Home from './pages/Home/'

import "./App.css";
import "./Responsive.css";

// import("./App.css").then(math => {
//   // console.log(math.add(16, 26));
// });

// const Home = loadable(() => import('./pages/Home/'),{
//   fallback: <Loading />
// })
const Home = loadable(() => import("./pages/Home/"));
// const VideoProduction = loadable(() => import('./pages/VideoProduction/'))
const SocialMediaAssets = loadable(() => import("./pages/SocialMediaAssets/"));
const SocialMediaMarketing = loadable(() =>
  import("./pages/SocialMediaMarketing/")
);
const SocialMediaMarketing2 = loadable(() =>
  import("./pages/SocialMediaMarketing2/")
);
const ExplainerVideoCompany = loadable(() =>
  import("./pages/ExplainerVideoCompany/")
);
const SocialMediaFun = loadable(() => import("./pages/SocialMediaFun/"));
const DigitalAdBanners = loadable(() => import("./pages/DigitalAdBanners/"));
const MessengerChatbots = loadable(() => import("./pages/MessengerChatbots/"));
const PaidAdvertisingServices = loadable(() =>
  import("./pages/PaidAdvertisingServices/")
);
const ContactUs = loadable(() => import("./pages/ContactUs/"));
const Cases = loadable(() => import("./pages/Cases/"));
const Industries = loadable(() => import("./pages/Industries/"));
const InternalCase = loadable(() => import("./pages/InternalCase/"));
const Pay = loadable(() => import("./pages/Pay/"));
const Scope = loadable(() => import("./pages/Scope/"));
const Team = loadable(() => import("./pages/Team/"));
const AboutUs = loadable(() => import("./pages/AboutUs/"));
const Testimonals = loadable(() => import("./pages/Testimonals/"));
const Feedback = loadable(() => import("./pages/Feedback/"));
const Quote = loadable(() => import("./pages/Quote/"));
const QuoteSMM = loadable(() => import("./pages/QuoteSMM/"));
const QuoteSMM2 = loadable(() => import("./pages/QuoteSMM2/"));
const QuoteAdvertising = loadable(() => import("./pages/QuoteAdvertising/"));
const QuoteBanners = loadable(() => import("./pages/QuoteBanners/"));
const CustomProposalSMM = loadable(() => import("./pages/CustomProposalSMM/"));
const Privacy = loadable(() => import("./pages/Privacy/"));
const PaymentTerms = loadable(() => import("./pages/PaymentTerms/"));
const PaymentSecurity = loadable(() => import("./pages/PaymentSecurity/"));
const PaymentInstruction = loadable(() =>
  import("./pages/PaymentInstruction/")
);
const PaymentError = loadable(() => import("./pages/PaymentError/"));
const ProdigiVsEveryone = loadable(() => import("./pages/ProdigiVsEveryone/"));
const Success = loadable(() => import("./pages/Success/"));

const ExplainerVideos = loadable(() => import("./pages/ExplainerVideos/"));
const EducationalVideos = loadable(() => import("./pages/EducationalVideos/"));
const MixedMediaVideos = loadable(() => import("./pages/MixedMediaVideos/"));
const EcommerceVideos = loadable(() => import("./pages/EcommerceVideos/"));
const ProductVideos = loadable(() => import("./pages/ProductVideos/"));

const SocialMediaVideos = loadable(() => import("./pages/SocialMediaVideos/"));
const CommercialVideos = loadable(() => import("./pages/CommercialVideos/"));
const SoftwareFeautureVideos = loadable(() =>
  import("./pages/SoftwareFeautureVideos/")
);
const D2Animation = loadable(() => import("./pages/2dAnimation/"));
const D3Animation = loadable(() => import("./pages/3dAnimation/"));
const Startup = loadable(() => import("./pages/Startup/"));
const Whiteboard = loadable(() => import("./pages/Whiteboard/"));

// const tagManagerArgs = {
//   gtmId: 'GTM-PMXZF5D'
// }

// TagManager.initialize(tagManagerArgs)

class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currency: "usd",
      country: "undefined",
      width: window.screen.width,
    };
    this.changeAppWidth = this.changeAppWidth.bind(this);
    if (window.location.search.indexOf("pro") > -1) {
      setCookie("weprodigi-pro", "true", 30);
    }
  }
  changeAppWidth() {
    this.setState({ width: window.innerWidth });
  }
  shouldComponentUpdate(nextProps, nextState) {
    if (this.state.width !== nextState.width) {
      if (
        (this.state.width < 1000 && nextState.width > 1000) ||
        (this.state.width > 1000 && nextState.width < 1000)
      ) {
        return true;
      } else {
        return false;
      }
    }
    return true;
  }
  componentDidMount() {
    const that = this;
    window.addEventListener("resize", function (e) {
      that.changeAppWidth();
    });
    fetch("https://geoip.weprodigi.com/")
      .then((res) => res.json())
      .then((response) => {
        this.setState({
          country: response.country,
          continent: response.continent,
        });
        if (response.continent === "Europe" && response.country !== "GB") {
          this.setState({ currency: "eur" });
        } else {
          switch (response.country) {
            case "US":
              this.setState({ currency: "usd" });
              break;
            case "GB":
              this.setState({ currency: "gbp" });
              break;
            case "AU":
              this.setState({ currency: "aud" });
              break;
            case "SG":
              this.setState({ currency: "sgd" });
              break;
            case "CA":
              this.setState({ currency: "cad" });
              break;
            case "RU":
              this.setState({ currency: "rub" });
              break;
            case "NZ":
              this.setState({ currency: "nzd" });
              break;
            default:
              this.setState({ currency: "usd" });
              break;
          }
        }
      });
    //       setTimeout(function(){
    //         (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    // new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    // j=d.createElement(s),dl=l!=='dataLayer'?'&l='+l:'';j.async=true;j.src=
    // 'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    // })(window,document,'script','dataLayer','GTM-PMXZF5D');
    //       },1500);
  }
  render() {
    return (
      <Router basename="/main">
        <Navigation
          continent={this.state.continent}
          country={this.state.country}
          width={this.state.width}
        />
        <Scroll />
        <div className="App">
          <Switch>
            <Route exact path="/">
              <Home />
            </Route>
            <Route path="/video-production-old">
              <VideoProduction
                currency={this.state.currency}
                country={this.state.country}
                width={this.state.width}
              />
            </Route>
            <Route path="/explainer-video-company">
              <ExplainerVideoCompany
                currency={this.state.currency}
                country={this.state.country}
                width={this.state.width}
              />
            </Route>
            <Route path="/social-media-fun">
              <SocialMediaFun
                currency={this.state.currency}
                country={this.state.country}
                width={this.state.width}
              />
            </Route>
            <Route path="/social-media-assets">
              <SocialMediaAssets
                currency={this.state.currency}
                country={this.state.country}
                width={this.state.width}
              />
            </Route>
            <Route path="/social-media-marketing">
              <SocialMediaMarketing
                currency={this.state.currency}
                country={this.state.country}
                width={this.state.width}
              />
            </Route>
            <Route path="/social-media-marketing-services">
              <SocialMediaMarketing2
                currency={this.state.currency}
                country={this.state.country}
                width={this.state.width}
              />
            </Route>
            <Route path="/digital-ad-banners">
              <DigitalAdBanners
                currency={this.state.currency}
                country={this.state.country}
                width={this.state.width}
              />
            </Route>
            <Route path="/messenger-chatbots-and-stickers">
              <MessengerChatbots
                currency={this.state.currency}
                country={this.state.country}
                width={this.state.width}
              />
            </Route>
            <Route path="/paid-advertising-services">
              <PaidAdvertisingServices
                currency={this.state.currency}
                country={this.state.country}
                width={this.state.width}
              />
            </Route>
            <Route path="/cases">
              <Cases width={this.state.width} />
            </Route>
            <Route path="/case/:caseId" component={InternalCase} />
            <Route path="/industries">
              <Industries width={this.state.width} />
            </Route>
            {/* <Route path="/case">
            <InternalCase width={this.state.width}></InternalCase>
          </Route> */}
            <Route path="/team">
              <Team width={this.state.width} />
            </Route>
            <Route path="/about-company">
              <AboutUs width={this.state.width} />
            </Route>
            <Route path="/testimonals">
              <Testimonals
                country={this.state.country}
                width={this.state.width}
              />
            </Route>
            <Route path="/contact-us">
              <ContactUs
                continent={this.state.continent}
                country={this.state.country}
                width={this.state.width}
              />
            </Route>
            <Route path="/privacy">
              <Privacy width={this.state.width} />
            </Route>
            <Route path="/feedback">
              <Feedback width={this.state.width} />
            </Route>
            <Route path="/quote">
              <Quote country={this.state.country} width={this.state.width} />
            </Route>
            <Route path="/quote-smm">
              <QuoteSMM country={this.state.country} width={this.state.width} />
            </Route>
            <Route path="/quote-smm2">
              <QuoteSMM2
                country={this.state.country}
                width={this.state.width}
              />
            </Route>
            <Route path="/quote-banners">
              <QuoteBanners
                country={this.state.country}
                width={this.state.width}
              />
            </Route>
            <Route path="/quote-advertising">
              <QuoteAdvertising
                country={this.state.country}
                width={this.state.width}
              />
            </Route>
            <Route path="/smm-custom-proposal">
              <CustomProposalSMM
                country={this.state.country}
                width={this.state.width}
              />
            </Route>
            <Route path="/payment-terms">
              <PaymentTerms width={this.state.width} />
            </Route>
            <Route path="/payment-security">
              <PaymentSecurity width={this.state.width} />
            </Route>
            <Route path="/payment-instruction">
              <PaymentInstruction width={this.state.width} />
            </Route>
            <Route path="/prodigi-vs-everyone">
              <ProdigiVsEveryone width={this.state.width} />
            </Route>
            <Route path="/explainer-videos">
              <ExplainerVideos width={this.state.width} />
            </Route>
            <Route path="/mixed-media-videos">
              <MixedMediaVideos width={this.state.width} />
            </Route>
            <Route path="/ecommerce-and-online-shopping-videos">
              <EcommerceVideos width={this.state.width} />
            </Route>
            <Route path="/educational-videos">
              <EducationalVideos width={this.state.width} />
            </Route>
            <Route path="/product-videos">
              <ProductVideos width={this.state.width} />
            </Route>
            <Route path="/commercial-videos">
              <CommercialVideos width={this.state.width} />
            </Route>
            <Route path="/social-media-videos">
              <SocialMediaVideos width={this.state.width} />
            </Route>
            <Route path="/software-feauture-videos">
              <SoftwareFeautureVideos width={this.state.width} />
            </Route>
            <Route path="/2d-animation">
              <D2Animation width={this.state.width} />
            </Route>
            <Route path="/3d-animation">
              <D3Animation width={this.state.width} />
            </Route>
            <Route path="/whiteboard-animation">
              <Whiteboard width={this.state.width} />
            </Route>
            <Route path="/startup">
              <Startup width={this.state.width} />
            </Route>
            <Route path="/pay/:hash" component={Pay} />
            <Route path="/scope/:hash" component={Scope} />
            <Route path="/success">
              <Success width={this.state.width} />
            </Route>
            <Route path="/error">
              <PaymentError width={this.state.width} />
            </Route>
            <Route path="/dashboard"></Route>
          </Switch>
        </div>
        <Footer country={this.state.country} width={this.state.width} />
      </Router>
    );
  }
}
export default App;
